import { SearchResult } from "./components/searchResult";
import { connect } from "react-redux";
import { ALL, NEWS, SET_ALL, SET_NEWS, SET_PAGE_SIZE } from "./enums";
import {
  getPaginatedSearchResults,
  getPaginatedNewsSearchResults,
} from "./selectors/searchResults";
import { useEffect, useRef, useState } from "react";
import {kebabCase} from 'lodash';

function App({ searchResults, newsSearchresults, dispatch }) {
  const [page, setPage] = useState(0);
  const loader = useRef(null);

  const searchResultTypeChanged = (searchResultType) => {
    //update the search result type shown
    switch (searchResultType) {
      case ALL:
        dispatch({ type: SET_ALL });
        break;
      case NEWS:
        dispatch({ type: SET_NEWS });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    //add search terms to the url hash and clear form state for the search results page
    //so we don't get the 're-submit form' warning
    window.history.replaceState( null, null, window.location.href);
    console.log('window location hash: ', window.location.hash);
    if (window.location.hash.length === 0 && window.searchResults && window.searchResults.length > 0) {
      console.log('cleared history, add hash for search term');
      window.location.hash = 'search-term=' + kebabCase(window.searchTerms);
    }
  }, []);

  useEffect(() => {
    //If the user clicks a search results then clicks back the results will need to be loaded again.
    //if we load in with no search results (window.searchResults is null or empty) and there's a location hash and the location hash does not contain 'r=1'
    //populate the search box with whatever is in location.hash and submit the form again
    if (window.searchResults.length === 0 && window.location.hash.length > 0) {
      let form = document.getElementById('site-search-form');
      let input = document.getElementById('Keywords');
      let hashSearchTerm = window.location.hash.replace('#search-term=', '');
      input.value = hashSearchTerm.replace(/-/g, ' ');
      form.submit(); //this will clear the location hash
    }
  }, []);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "20px",
      threshold: 1.0,
    };

    //init an observer and use the (former) load more button as the target
    const observer = new IntersectionObserver(handleObserver, options);

    if (loader.current) {
      observer.observe(loader.current);
    }
  }, []);

  useEffect(() => {
    //watch the page state above (changed by handleObserver)
    //and dispatch an increase in pageSize to load 10 search results into the list
    const timer = setTimeout(() => {
      if (page > 0) {
        dispatch({ type: SET_PAGE_SIZE });
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [page, dispatch]);

  const handleObserver = (entities) => {
    const target = entities[0];

    if (target.isIntersecting) {
      //Check the target (ref={loader}) is in the viewable area
      //and change the page variable above to a new number thus
      //triggering the useEffect that's watching [page].
      //Using dispatch does work but eslint throws an error so we'll
      //maintain 0 deps for this function and put the dispatch in a useEffect above
      setPage(new Date().getTime());
    }
  };

  return (
    <>
      {/*{searchResults.length > 0 && (
                <div class="flex flex-row gap-4 my-8">
                    <a
                        class="button"
                        onClick={() => searchResultTypeChanged(ALL)}
                    >
                        All
                    </a>
                    <a
                        class="button"
                        onClick={() => searchResultTypeChanged(NEWS)}
                    >
                        News
                    </a>
                </div>
            )}*/}

      {searchResults.length > 0 &&
        searchResults.map((node) => (
          <SearchResult key={node.Id} {...node} />
        ))}

      {searchResults.length === 0 && (
        <p>We couldn't find any results matching your search term.</p>
      )}

      {searchResults.length > 0 && <div ref={loader}></div>}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    searchResults: getPaginatedSearchResults(state),
    newsSearchresults: getPaginatedNewsSearchResults(state),
  };
};

export default connect(mapStateToProps)(App);
